import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
const json = {
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page5/Key/E1answerKey.jpg",
    component: T6,
    textAlign: "center",
    hideBtnFooter: true,
    // maxLength: 1,
    inputSize: 81,
    stylesTextInput: { borderBottom: "none", fontSize: "20px" },
    textareaStyle: { width: 800 },
    titleQuestion: [
      {
        num: "",
        title: `
        <div style='font-size:30px;color:rgb(32 62 111)'>ĐỌC MỞ RỘNG</div>
				`,
        color: "rgb(29,193,215)",
      },
    ],

    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    isEssay: true,
    questions: [
      {
        title: `
          
          <div style='width:20cm;margin:20px 0px'>
            <div>
              <b style='color:rgb(3, 103, 181)'>1.</b>&ensp;Đọc câu chuyện về người có năng khiếu nổi bật.<br>
              <div style='display:flex;margin-left:50px'>
                  <b style='margin-right:20px;color:rgb(158 59 56)'>G.</b>
                  <div>
                    - Thần đồng đất Việt <br>
                    - Danh nhân thế giới
                  </div>
              </div>
            </div>
            <div>
              <b style='color:rgb(3, 103, 181)'>2.</b>&ensp;Viết phiếu đọc sách theo mẫu.<br>
              
            </div>
            <table style="border-collapse: collapse; width: 27cm; margin-left: -70px ;">
                <tr style="text-align: center; background-color: rgb(200,212,238); border: 2px solid black; display: table-caption;">
                  PHIẾU ĐỌC CHUYỆN
                </tr>
                <tr style="">
                  <td style="width:107mm; border: 2px solid black; padding: 0px; ">Tên câu chuyện: ✹<input id='0' width='150px'></input></td>
                  <td style=" border: 2px solid black; padding: 5px;">Tác giả: ✹<input id='1' width='170px'></input></td>
                  <td style="width:8cm;border: 2px solid black; padding: 10px;">Ngày đọc: ✹<input id='2' width='130px'></input></td>
                </tr>
                <tr style="border: 2px solid black; padding-left: 10px">
                  Tên nhân vật: ✹<input id='3' width='200px'></input>
                </tr>
                <tr style="border: 2px solid black; padding-left: 10px">
                  Năng khiếu nổi bậc của nhân vật: ✹
                  <td><input id='4' width='300px'></input></td>
                </tr>
                <tr style="border: 2px solid black; padding-left: 10px">
                  Mức độ yêu thích: ☆ ☆ ☆ ☆ ☆ 
                </tr>
            </table>
              <b style='color:rgb(3, 103, 181)'>3.</b>&ensp;Trao đổi với bạn về nội dung em đã đọc.<br>
              
           
          </div>
          <div style='display:flex;margin-left:-140px'>
            <img src='/img/FriendsPlus/Page5/E3/1.jpg' style='height:15mm;margin-right:50px' /> 
            <div>
              Kể với người thân một câu chuyện của tác giả mà em yêu thích.
            </div>
          

        `,
        answer: [
          "Do",
          "has",
          "doesn't",
          "Does",
          "'m",
          "'re",
          "having",
          "aren't",
          "isn't",
          "Is",
        ],
      },
    ],
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P8-E2",
    audio: "",
    component: T6v2,
    // hideBtnFooter: true,
    inputSize: 150,
    exerciseKey: "/img/FriendsPlus/Page8/Key/E2answerKey.jpg",
    stylesTextInput: {
      fontSize: "22px",
      textAlign: "center",
    },
    titleQuestion: [
      {
        num: "2",
        title: `				
				Complete the sentences with the words.
				`,
        color: "rgb(1,105,184)",
        star: 2,
      },
    ],
    questionImage: [],
    isHiddenCheck: true,
    questions: [
      {
        title: `
				<div style='margin-top: 20px; display: flex; gap: 30px;max-width:410px;margin-left:120px;margin-bottom:20px'>
        <div style='flex: 1; border-radius: 20px; padding: 20px 30px; border: 4px solid rgb(169,225,236);'>
          <div>
          <span style="margin-right:20px">apps</span><span style="margin-right:20px">fad</span><span style="margin-right:20px">fan</span><span style="margin-right:20px">followers</span><span>post</span></div>
          <span style="margin-right:20px;margin-left:60px">social media</span><span style="text-decoration:line-through">views</span></div>
          
        </div>
        <div>
          <div>The video went viral and received over a million <strong style="margin-left:15px">views</strong></div>
          <div>
            <strong style="marign-right:20px;">1</strong> Are you a # of any celebrities or sports teams?<br>
            <strong style="marign-right:20px;">2</strong> The website Myspace was a # because it was only popular for a few years.<br>
            <strong style="marign-right:20px;">3</strong> People post comments on # sites like Twitter and Facebook.<br>
            <strong style="marign-right:20px;">4</strong>  A lot of smartphone # are free.<br>
            <strong style="marign-right:20px;">5</strong> My friend wrote a great # about her trip to Canada.<br>
            <strong style="marign-right:20px;">6</strong> She has got over 100,000 # on Twitter.<br>
          </div>
        </div>
        `,
        answer: ["fan", "fad", "social media", "apps", "post", "followers"],
      },
    ],
  },
  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P8-E3",
    audio: "",
    exerciseKey: "/img/FriendsPlus/Page8/Key/E3answerKey.jpg",
    component: T6v2,
    inputSize: 150,
    stylesTextInput: {
      fontSize: "22px",
      background: "transparent",
      textAlign: "left",
      borderStyle: "dotted",
    },
    titleQuestion: [
      {
        num: "3",
        title: `				
				Complete the words for the definitions.
				`,
        color: "rgb(1,105,184)",
        star: 2,
      },
    ],
    questionImage: [],
    isHiddenCheck: true,
    questions: [
      {
        title: `
				<div>
          <div>something that many people are into for a short time <strong>craze</strong>.</div>
          <div><strong style="margin-right:20px">1</strong>a person who reads another person’s posts online <b>f</b>#</div>
          <div><strong style="margin-right:20px">2</strong>websites for making friends and talking to people <b>s</b>#</div>
          <div><strong style="margin-right:20px">3</strong>the number of times people visit a web page or online video <b>v</b>#</div>
          <div><strong style="margin-right:20px">4</strong>some writing or an image put on social media <b>p</b>#</div>
          <div><strong style="margin-right:20px">5</strong>a computer program for a particular use <b>a</b>#</div>
          <div><strong style="margin-right:20px">6</strong>a small and useful machine or tool  <b>g</b>#</div>
        </div>
        `,
        answer: ["ollower", "ocial media", "iews", "ost", "pp", "adget"],
      },
    ],
  },
  4: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page5/Key/E1answerKey.jpg",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    inputSize: 81,
    textareaStyle: { width: 800 },
    titleQuestion: [
      {
        num: "",
        title: `
        <div style='margin-left:120px;font-size:30px;color:rgb(102 96 132)'>VIẾT ĐOẠN VĂN NÊU Ý KIẾN</div>
				`,
        color: "rgb(29,193,215)",
      },
    ],

    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    isEssay: true,
    questions: [
      {
        title: `
            <div style='width:20cm;border: 5px solid rgb(29,193,215);padding:5px 10px;border-radius:20px;box-shadow:0px 2px 3px 4px gray'>
              
              <b>Đề bài:</b> Viết đoạn văn nêu lý do yêu thích một câu chuyện về tình cảm gia đình mà em đã đọc hoặc đã nghe <br>
             
            </div>   
          <div style='width:20cm;margin:20px 0px'>
            <div>
              <b style='color:rgb(3, 103, 181)'>1.</b>&ensp;Dựa vào các ý đã tìm trong hoạt động Viết của bài 3, viết đoạn văn nêu lí do. 
               yêu thích của một câu chuyện đã đọc hoặc đã nghe.<br>
               Lưu ý:<br>
              - Chọn cách giới thiệu câu chuyện gây được chú ý và nêu nhận xét, đánh giá chung về câu chuyện.<br>
              - Trình bày rõ các lí do yêu thích câu chuyện và đưa ra dẫn chứng minh họa.
              - Các câu trong đoạn văn được viết liên tục, không xuống dòng.
            </div>
              <b style='color:rgb(3, 103, 181)'>2.</b>&ensp; Đọc soát và chỉnh sửa bài viết.<br>
            <div style='width:25cm'>
              <span style='background:yellow; padding:6px 40px; text-align:center'>
                Cách mở đoạn
              </span>            
              <span style='background:rgb(227 199 202); padding:6px 40px; text-align:center;margin:0px 10px'>
                Cách trình bày lí do
              </span>            
              <span style='background:rgb(204 218 221); padding:6px 40px; text-align:center'>
                Cách kết thúc
              </span>            
            </div>
            <div style='width:20cm;margin:20px 70px'>
              <span style='background:yellow; padding:6px 40px; text-align:center;margin:0px 10px'>
                Cách dùng từ
              </span>            
              <span style='background:rgb(227 199 202); padding:6px 40px; text-align:center'>
                Cách thức trình bày đoạn văn
              </span>            
                      
            </div>
            
              <b style='font-weight:bold'>
                 Bài làm:
              </b>
                    <textarea id='0' rows='8'></textarea>

        `,
        answer: [
          "Do",
          "has",
          "doesn't",
          "Does",
          "'m",
          "'re",
          "having",
          "aren't",
          "isn't",
          "Is",
        ],
      },
    ],
  },
};

export default json;
